//React
import React from "react";


class Comp extends React.Component {

	render() {
    let characterStar = [];
    if (this.props.count > 0) {
      for (let i = 1; i <= this.props.count; i++) {
        characterStar.push(
          <span
						key={i}
						role="img"
						aria-labelledby="star"
						style={ this.props.style }
					>
						⭐️
					</span>
        );
      }
    }

		return (
			<span>
        {
          characterStar
        }
			</span>
		)
	}
}

export default Comp;
